import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';

import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

// --- 關鍵修改：將所有頁面改為 Lazy Load (懶加載) ---
// 這樣做之後，用戶訪問首頁時，就不會下載 Admin 或其他頁面的代碼
const HomePage = lazy(() => import('./pages/HomePage'));
const AdminLoginPage = lazy(() => import('./pages/AdminLoginPage'));
const AdminPage = lazy(() => import('./pages/AdminPage'));
const AdminPanel = lazy(() => import('./pages/AdminPanel'));
const FeedbackPage = lazy(() => import('./pages/FeedbackPage'));
const AdminSubmissionsPage = lazy(() => import('./pages/AdminSubmissionsPage'));
const AdminBulkUploadPage = lazy(() => import('./pages/AdminBulkUploadPage'));
const AdminNewsPage = lazy(() => import('./pages/AdminNewsPage'));
const NewsPage = lazy(() => import('./pages/NewsPage'));
const NewsDetailPage = lazy(() => import('./pages/NewsDetailPage'));
const AdminMediaManagerPage = lazy(() => import('./pages/AdminMediaManagerPage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));
const SitemapGeneratorPage = lazy(() => import('./pages/SitemapGeneratorPage'));

// 一個簡單的 Loading 畫面，當切換頁面下載代碼時顯示
const PageLoader = () => (
  <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh', 
      width: '100vw' 
  }}>
    <div className="loading-spinner"></div>
  </div>
);

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <Router>
          <main className="app-main-content">
            {/* Suspense 用於處理 Lazy Load 組件載入時的過渡狀態 */}
            <Suspense fallback={<PageLoader />}>
              <Routes>
                {/* --- 公開路由 --- */}
                <Route path="/" element={<HomePage />} />
                <Route path="/location/:locationSlug" element={<HomePage />} />
                <Route path="/shop/:shopId/:shopName?" element={<HomePage />} />
                
                <Route path="/admin/login_pw_ab341" element={<AdminLoginPage />} />
                <Route path="/feedback" element={<FeedbackPage />} />
                <Route path="/news" element={<NewsPage />} />
                <Route path="/news/:newsId" element={<NewsDetailPage />} /> 

                {/* --- 受保護的管理員路由 --- */}
                <Route element={<ProtectedRoute />}>
                  <Route path="/admin" element={<AdminPage />} />
                  <Route path="/admin-panel" element={<AdminPanel />} />
                  <Route path="/admin/submissions" element={<AdminSubmissionsPage />} />
                  <Route path="/admin/bulk-upload" element={<AdminBulkUploadPage />} />
                  <Route path="/admin/news" element={<AdminNewsPage />} />
                  <Route path="/admin/media" element={<AdminMediaManagerPage />} />
                  <Route path="/admin/sitemap" element={<SitemapGeneratorPage />} />
                </Route>

                {/* --- 萬用路由 --- */}
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </Suspense>
          </main>
        </Router>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;